import { setWithExpiry } from './local-storage.js';

const verifyCode = (codigodeverificacao) => {
    jQuery(document).ready(function($) {
        $(document).on('submit', '#form-verification', function(event) {
            event.preventDefault();

            const inputValueVerify = $('#form-field-codigo-verify').val();
            console.log(codigodeverificacao);

            if (inputValueVerify == codigodeverificacao) {
                elementorProFrontend.modules.popup.closePopup({}, event);
                const daysInThreeMonths = 90;
                const expireTimeMs = daysInThreeMonths * 24 * 60 * 60 * 1000;
                setWithExpiry('userChecked', true, expireTimeMs);
                console.log('User successfully verified and marked as checked.');
            } else {
                window.alert('Código de verificação errado');
            }
        });
    });
};

export { verifyCode };
